import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineBagPercent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8 14.825c3.369 0 5.775-1.3 5.775-4.193 0-3.146-1.444-5.242-4.331-6.815l1.135-1.594a.74.74 0 0 0 .01-.694.67.67 0 0 0-.23-.257.6.6 0 0 0-.319-.097H5.96a.6.6 0 0 0-.319.097.67.67 0 0 0-.23.257.74.74 0 0 0 .01.694l1.135 1.604c-2.887 1.584-4.331 3.68-4.331 6.826 0 2.872 2.406 4.172 5.775 4.172"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M5.65 8.35a.7.7 0 1 0 1.4 0 .7.7 0 1 0-1.4 0m3.3 2.7a.7.7 0 1 0 1.4 0 .7.7 0 1 0-1.4 0M9.3 8.1l-2.6 3.45"
    />
  </svg>
);
export default SvgStreamlineBagPercent;
